import { CreditCard, CreditCardType } from "../types/CreditCard";
import { startNumberJCB } from "../constants";
import CreditCards from "../functions/creditCards";

export class CreditCardJCB implements CreditCard {
    getType(): CreditCardType {
        return CreditCardType.JCB;
    }
    compare(number?: string): boolean {
        return CreditCards.compare(startNumberJCB, number);
    }
    getImageUrl() {
        return `${process.env.REACT_APP_PAY_HOST}/assets/creditcards/jcb.png`;
    }
}